import { isNumber } from 'lodash-es'

window.anonymousForm = {}

window.anonymousForm.filterAnonymous = (data) => {

    if (data.hasOwnProperty('postcode')) {
        while (data.postcode.match(/[-]/)) {
            data.postcode = data.postcode.replace(/[-]/, '')
        }

        while (data.postcode.match(/[\s]/)) {
            data.postcode = data.postcode.replace(/[\s]/, '')
        }
    }

    if (data.hasOwnProperty('telefoon')) {
        while (data.telefoon.match(/[-]/)) {
            data.telefoon = data.telefoon.replace(/[-]/, '')
        }

        while (data.telefoon.match(/[\s]/)) {
            data.telefoon = data.telefoon.replace(/[\s]/, '')
        }

        data.telefoon = data.telefoon.replace('+310', '+31')
    }

    if (data.hasOwnProperty('emailadres')) {
        while (data.emailadres.match(/[\s]/)) {
            data.emailadres = data.emailadres.replace(/[\s]/, '')
        }

        data.emailadres = data.emailadres.toLowerCase()
    }

    return data
}

window.anonymousForm.validateAnonymous = (data, asHTMLList = false) => {

    const errors = []

    const addError = (selector, message) => {
        errors.push({
            selector,
            message,
        })
    }

    if (data.hasOwnProperty('postcode') && data.postcode != '') {

        if (!data.postcode.match(/^[1-9][0-9]{3}[A-Za-z]{2}$/i)) {
            addError('postcode', 'De ingevoerde postcode is ongeldig.')
        }
    }

    if (data.hasOwnProperty('emailadres') && data.emailadres != '') {

        if (!validateEmailadres(data.emailadres)) {
            addError('emailAdres', 'Het ingevoerde e-mailadres is ongeldig.')
        }
    }

    if (asHTMLList) {
        if (!errors.length) {
            return ''
        }
        const uniqueErrors = [...new Set(errors.map((error) => error.message))]
        return uniqueErrors.reduce((acc, cur) => {
            acc += '<li>' + cur + '</li>'
            return acc
        },'<ul>') + '</ul>'
    }

    return errors
}
